export const parsePhoneNumber = function (countryCode, phoneNumber: string, isLoginFlow?: boolean) {
  if (isLoginFlow) {
    return `(***) ***-${phoneNumber.slice(phoneNumber.length - 4, phoneNumber.length)}.`;
  }
  return `(${countryCode}) ${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, phoneNumber.length)}.`;
};
